import { render, staticRenderFns } from "./SelectContentTemplateType.vue?vue&type=template&id=71815f9c&scoped=true&"
import script from "./SelectContentTemplateType.vue?vue&type=script&lang=ts&"
export * from "./SelectContentTemplateType.vue?vue&type=script&lang=ts&"
import style0 from "./SelectContentTemplateType.vue?vue&type=style&index=0&id=71815f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71815f9c",
  null
  
)

export default component.exports